// Volle Navigation weg von der Shell (Abmelden, Kontowechsel). Solange sie läuft, leitet das
// Login-Gate nicht zusätzlich um – sonst bricht die zweite Navigation die erste ab.
let leaving = false;

export function navigateAway(url: string, { replace = false }: { replace?: boolean } = {}) {
  leaving = true;
  if (replace) window.location.replace(url);
  else window.location.assign(url);
}

export function isNavigatingAway(): boolean {
  return leaving;
}

/** Nur für Tests: Zustand zwischen Fällen zurücksetzen. */
export function resetNavigateAway() {
  leaving = false;
}
